import { FaturaAnaSayfaPage } from './../fatura-ana-sayfa/fatura-ana-sayfa';
import { BllSiparisDetay } from './../../../providers/bll/bll-siparis-detay';
import { BllOrtak } from './../../../providers/bll/bll-ortak';
import { Component } from '@angular/core';
import { NavController, NavParams, ViewController } from 'ionic-angular';
import { Ortak } from '../../../providers/ortak';



@Component({
  selector: 'page-faturaonayla',
  templateUrl: 'faturaonayla.html',
})
export class FaturaonaylaPage {
  gidecekFaturaOzellik: any = { CariID: "", ToplamTutar: "", Method: "" };
  faturaJson: any = { Aciklama: "", FaturaTarih: "", VadeTarih: "", CariID: "", ToplamTutar: "", Method: "" }
  aktifkullaniciadi = "";
  stoktandussunmu:number=1;
  evethayir=[];
  sipID:number=0;
  suankitarih: any;
  constructor(public navCtrl: NavController,
    public ortak: Ortak,
    public viewCtrl: ViewController,
    public bllOrtak: BllOrtak,
    public navParams: NavParams) {
    if (navParams.get("Fatura") != null) {
      this.gidecekFaturaOzellik = navParams.get("Fatura");

      this.faturaJson.CariID = this.gidecekFaturaOzellik.CariID;
      this.faturaJson.ToplamTutar = this.gidecekFaturaOzellik.ToplamTutar;
      this.faturaJson.Method = this.gidecekFaturaOzellik.Method;
      if(this.faturaJson.Method=="SatisFatKaydet")
      {
        this.sipID=-995;
      }
      if(this.faturaJson.Method=="AlisFatKaydet")
      {
        this.sipID=-994;
      }
      if(this.faturaJson.Method=="PerakendeFatKaydet")
      {
        this.sipID=-993;
      }

    }
    this.aktifkullaniciadi = this.ortak.aktifKullaniciAdi;
    this.suankitarih = new Date().toUTCString();
    this.suankitarih = this.ortak.tarih(this.suankitarih);
    this.faturaJson.FaturaTarih = new Date().toISOString();
    this.faturaJson.VadeTarih = this.suankitarih;
    this.evethayir = [{
      "ID": "0",
      "Adi": "Hayır"
    },
    {
      "ID": "1",
      "Adi": "Evet"
    }
    ];
  }

  Onayla() {
    var bllSiparisDetay = new BllSiparisDetay();
    bllSiparisDetay.getAll({ siparisID: this.sipID }).then(a => {
      var formData = new FormData();
      console.log("fat",this.faturaJson);
      this.faturaJson.ToplamTutar = this.faturaJson.ToplamTutar;
      formData.append("stokhareket", JSON.stringify(a));
      formData.append("cariid", this.faturaJson.CariID.toString());
      formData.append("faturatutar", this.faturaJson.ToplamTutar.toString());
      formData.append("islemiyapan", this.aktifkullaniciadi.toString());
      formData.append("faturaaciklama", this.faturaJson.Aciklama.toString());
      formData.append("vadetarihi", this.ortak.tarih(this.faturaJson.VadeTarihi));
      formData.append("faturatarih", this.ortak.tarih(this.faturaJson.FaturaTarih));
      if(this.faturaJson.Method=="SatisFatKaydet")
      {
        formData.append("stokdussunmu",this.stoktandussunmu.toString());
      }
      console.log("stokhareket", JSON.stringify(a));
      console.log("cariid", this.faturaJson.CariID.toString());
      console.log("faturatutar", this.faturaJson.ToplamTutar.toString());
      console.log("islemiyapan", this.aktifkullaniciadi.toString());
      console.log("faturaaciklama", this.faturaJson.Aciklama.toString());
      console.log("vadetarihi", this.ortak.tarih(this.faturaJson.VadeTarihi));
      console.log("faturatarih", this.ortak.tarih(this.faturaJson.FaturaTarih));
      this.bllOrtak.islem(formData, this.faturaJson.Method, "Fatura kaydediliyor lütfen bekleyiniz..", true).then(a => {
        var sonuc = <any>a;

        console.log("hata",sonuc);
        if (sonuc.Sonuc == 1) this.ortak.showBasicAlert("Uyarı", "Fatura Başarılı Bir Şekilde EKlenmiştir");
        bllSiparisDetay.execRawQuery("DELETE FROM NL_Siparis WHERE siparisID = " + this.sipID).then(b => {
          this.navCtrl.setRoot(FaturaAnaSayfaPage);
        })
      })
    });
  }
  kapat() {
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/faturaislemleri/faturaonayla/faturaonayla.ts